import type { ReactNode } from 'react'
import React from 'react'
import { HorizontalStack } from '@ztechapps/webui.util'
import { IconOnCircle } from '../components/icon-on-circle'

export const SpecialtyCard = ({
  icon,
  iconClassName,
  title,
  description,
}: {
  icon: string
  iconClassName: string
  title: ReactNode
  description: ReactNode
}) => {
  return (
    <HorizontalStack gap={3} className="align-items-start">
      <div>
        <IconOnCircle icon={icon} className={iconClassName} />
      </div>
      <div>
        <h6 className="fw-bold">{title}</h6>
        <p className="text-muted">{description}</p>
      </div>
    </HorizontalStack>
  )
}
